import {TagColor} from '@/model/const';
import Utils from '@/util/utils';
import {StarFilled, StarOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import React from 'react';
import {useNavigate} from 'react-router';
import './name-code.scss';
export interface NameCodeProps {
    name: string;
    code: string;
    color?: number;
    expireTime?: number;
    star?: number;
    onStarClick?: (star: number) => void;
}

const NameCode: React.FC<NameCodeProps> = (props) => {
    const {name, code, color = 0, expireTime, star = 0, onStarClick} = props;
    const navigate = useNavigate();

    const renderStar = () => {
        if (!onStarClick) return;
        return star ? (
            <StarFilled className="star star-fill" onClick={() => onStarClick(0)} />
        ) : (
            <StarOutlined className="star" onClick={() => onStarClick(1)} />
        );
    };

    const handleInfoDetail = () => {
        navigate(`/info/${code}`);
    };

    return (
        <div className="name-code">
            {expireTime ? (
                <div className="name name-disable">
                    <Tooltip title={`到期：${Utils.formatDate(expireTime)}`}>
                        <span onClick={handleInfoDetail} className="pointer">
                            {name}
                        </span>
                        {renderStar()}
                    </Tooltip>
                </div>
            ) : (
                <div className="name">
                    <span onClick={handleInfoDetail} className="pointer">
                        {name}
                    </span>
                    {renderStar()}
                </div>
            )}
            <div className="wrap">
                <div className="code pointer" onClick={handleInfoDetail}>
                    {code}
                </div>
                <div className="color" style={{backgroundColor: TagColor[color % TagColor.length]}} />
            </div>
        </div>
    );
};

export default NameCode;
